import { NamedEntry } from "./NamedEntry";

export class CdReferenceTypes{
    /**Отменяет ВНД. */
    static CancellInternalDocuments = new NamedEntry("f44f9b08-79ec-4f67-94b7-3d48dc5e5f13", "Отменяет ВНД")

    /**Утверждает ВНД. */
    static ConfirmInternalDocuments = new NamedEntry("350a21ae-93f9-4cf6-a1ee-a6dcd31bf621", "Утверждает ВНД")

    /**Ссылка. */
    static LinkDocuments = new NamedEntry("663c7e30-3977-4790-b6cc-14612342da24", "Ссылка")
}